module.exports = __webpack_public_path__ + "img/bird.6631edef.png";